import React, { useState, useEffect } from 'react';
import { Form, Select, Table, Typography, Popconfirm, message, Input } from 'antd';
import { CheckCircleTwoTone, WarningTwoTone } from '@ant-design/icons';
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import DropdownActionsTable from './DropdownActionsTable';
import axios from "./../../../services/http";
const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});

const TablaMontosCmp = ({ from, amounts, typesPayment, subtotalLabel, subtotal, refreshData, openDialogFilesWithParams, amountForm }) => {

    const navigate = useCustomNavigate();
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const [messageApi, contextHolder] = message.useMessage();

    const EditRow = (record) => {
        setEditingKey(record.key);
        amountForm.setFieldsValue({
            tipo_de_pago: (record.tipo_de_pago !== null && record.tipo_de_pago !== undefined ? record.tipo_de_pago : null),
            ...record,
        });
    }
    const UpdateRelationship = async (record) => {
        try {
            const editRow = await amountForm.validateFields();
            messageApi.open({ type: 'loading', content: 'Actualizando relación de pago....', duration: 0 });
            const response = await axios.HTTP_POST("/api/v1/relationship/update", { 
                tipo_de_pago: editRow.tipo_de_pago, 
                obraId: from.id, 
                numero_relacion: record.numero_relacion, 
                id: record.id,
                importe: editRow.importe,
                tipo_monto: record.tipo_monto,
            })
            if (response) {
                messageApi.destroy();
                message.success(response.data.msg);
                setEditingKey('');
                refreshData();
            }
    
        } catch (e) {
            console.log("err**",e);
        }
    }
    const Cancel = () => setEditingKey("");

    const columns = [
        {
            title: 'ID',
            dataIndex: 'partida_cp',
            render: (_, payment) => <>{ payment.partida }</>
        },
        {
            title: 'Tipo de Pago',
            dataIndex: 'tipo_de_pago',
            key: 'tipo_de_pago',
            width: '15%',
            editable: true,
        },
        {
            title: 'Relación',
            dataIndex: 'numero_relacion',
            key: 'numero_relacion',
        },
        {
            title: 'Obra',
            render: () => from.nombre_obra,
            key: 'obra',
        },
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (fecha_cp) => {
                return (
                <span>{new Date(fecha_cp).toLocaleDateString("es-Mx") }</span>
                )
            },
        },
        {
            title: 'Contratista',
            dataIndex: 'nombre_contratista',
            key: 'nombre_contratista',
        },
        {
            title: 'Importe',
            dataIndex: 'importe',
            key: 'importe',
            render: (_, record) => {
                const importeDisplay = record.tipo_monto === 'Fiscal'
                    ? (record.importe + (record.importe * (record.cpIVA/100))) || 0
                    : record.importe || 0;
                return (
                    <a onClick={() => navigate("/payment-control-list", { state: { from: from, contratista_id: record.contratista_id, cp: record.control_pago_id } })}>
                        $ {numberFormat.format(parseFloat(importeDisplay)) || '0.00'}
                    </a>)
            },
            editable: true
        },
        {
            title: 'Observaciones',
            dataIndex: 'observaciones',
            key: 'observaciones',
        },
        {
            title: "Autorizado",
            dataIndex: "estatus",
            key: "estatus",
            align: 'center',
            render: (_, record) => (
                <>
                {record.estatus === "AUTORIZADO" && <CheckCircleTwoTone twoToneColor="#52c41a" />}
                {(record.estatus === "NO AUTORIZADO" && record.autorizacion_n1 === 0) && <><WarningTwoTone twoToneColor="#faad14" /> <span>(N1)</span></>}
                {(record.estatus === "NO AUTORIZADO" && record.autorizacion_n2 === 0) && <><WarningTwoTone twoToneColor="#faad14" /> <span>(N2)</span></>}
                </>
            )
        },
        {
        title: 'Acciones',
        dataIndex: 'operation',
        render: (_, record) => {
            const editable = isEditing(record);
            return editable ? (
                <span>
                    <Typography.Link
                        onClick={() => UpdateRelationship(record)}
                        style={{
                            marginInlineEnd: 8,
                        }}
                    >
                        Guardar
                    </Typography.Link>
                    <Popconfirm title="Seguro de cancelar?" onConfirm={Cancel}>
                        <a>Cancelar</a>
                    </Popconfirm>
                </span>
            ) : (
                <>
                    <DropdownActionsTable
                        record={record}
                        openDialogFilesWithParams={openDialogFilesWithParams}
                        edit={EditRow}
                        AuthRelationship={AuthRelationship}
                        deleteRelationship={deleteRelationship}
                    />
                </>
            );
        },
        },
    ];
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = inputType === 'select' ? <Select options={typesPayment} /> : <Input />;
        return (
        <td {...restProps}>
            {editing ? (
            <Form.Item
                name={dataIndex}
                style={{
                margin: 0,
                }}
                rules={[
                {
                    required: true,
                    message: `Ingresar ${title}!`,
                },
                ]}
            >
                {inputNode}
            </Form.Item>
            ) : (
            children
            )}
        </td>
        );
    };
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
        return col;
        }
        return {
        ...col,
        onCell: (record) => ({
            record,
            inputType: col.dataIndex === "tipo_de_pago" ? "select" : "text",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record) &&
                (col.dataIndex !== 'importe' || record.estatus === "NO AUTORIZADO"),
            }),
        };
    });

    const AuthRelationship = async (data, authLevel) => {
        try {
            messageApi.open({ type: 'loading', content: 'Actualizando relación de pago....', duration: 0 });
            const response = await axios.HTTP_POST("/api/v1/relationship/auth-relationship", { obra_id: from.id, numRelacion: parseInt(data.numero_relacion), levelAuth: authLevel, relacion_id: data.relacion_id })
            if (response) {
                messageApi.destroy();
                message.success(response.data.message);
                refreshData();
            }
        
        } catch (e) {
            console.error('Hubo un error al autorizar la relación de pago:', e);
            message.error('Hubo un error al autorizar la relación de pago.');
        }
    }

    const deleteRelationship = async data => {
        try {
            messageApi.open({ type: 'loading', content: 'Eliminando relación de pago....', duration: 0 });
            const response = await axios.HTTP_POST("/api/v1/relationship/delete-relationship", { relacion_id: data.relacion_id })
            if (response) {
                messageApi.destroy();
                message.success(response.data.message);
                refreshData();
            }

        } catch (e) {
            console.error('Hubo un error al eliminar la relación de pago:', e);
            message.error('Hubo un error al eliminar la relación de pago.');
        }
    }

    return (
        <>
            <Table
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                dataSource={amounts}
                columns={mergedColumns}
                pagination={false}
                size="small"
                footer={() => (
                    <div style={{ textAlign: 'right' }}>
                        <strong>{subtotalLabel}</strong> $ {numberFormat.format(subtotal) || '0.00'}
                    </div>
                )}
                rowKey={record => record.id}
            />
        </>
    )
}

export default TablaMontosCmp;